function setProductSize(e) {
    var currentSizes = document.getElementsByClassName("size");

    if (currentSizes) {
        for (var i = 0; i < currentSizes.length; i++) {
            currentSizes[i].classList.remove("current-size");
        }
    }

    e.classList.add("current-size");

    document.location = e.getAttribute("data-url");
}


function setProductInfo(e) {
    var id = e.id;
    var selectedInfoTab = document.querySelector(`[data-details-id="${id}"]`)
    var currentTabs = document.getElementsByClassName("detail-title");
    var currentInfoTabs = document.querySelectorAll(".details.column");

    if (currentTabs) {
        for (var i = 0; i < currentTabs.length; i++) {
            currentTabs[i].classList.remove("current-info");
            currentTabs[i].nextElementSibling.classList.add("hidden");

        }
    }

    if (currentInfoTabs) {
        for (var i = 0; i < currentInfoTabs.length; i++) {
            currentInfoTabs[i].classList.add("hide");
        }
    }

    selectedInfoTab.classList.remove("hide");
    e.classList.add("current-info");
    e.nextElementSibling.classList.remove("hidden")

}

window.setProductSize = setProductSize;
window.setProductInfo = setProductInfo;